import createIcon from "./createIcon";

export const ReverseIcon = createIcon('Reverse', (props) => {
  return (
    <svg {...props} viewBox="0 0 24 24">
      <path
        d="M5 13L14 13L14 11L5 11L5 13ZM14 13C14.5523 13 15 13.4477 15 14L15 19C15 19.5523 14.5523 20 14 20L5 20C4.44772 20 4 19.5523 4 19L4 14C4 13.4477 4.44772 13 5 13L5 11C3.34315 11 2 12.3432 2 14L2 19C2 20.6569 3.34315 22 5 22L14 22C15.6569 22 17 20.6569 17 19L17 14C17 12.3432 15.6569 11 14 11L14 13Z"
        fill="currentColor"
        fillRule="nonzero"
      />
      <g transform="matrix(-1,0,0,1,22,1)">
        <path
          d="M11.2929 0.292892C11.6834 -0.0976307 12.3166 -0.0976307 12.7071 0.292892L17.7071 5.29289C17.8022 5.388 17.8742 5.49751 17.923 5.6144C17.9726 5.73306 18 5.86333 18 6C18 6.27282 17.8908 6.52013 17.7136 6.70055C17.7115 6.70275 17.7093 6.70493 17.7071 6.70711C17.5261 6.88807 17.2761 7 17 7L5 7C4.20435 7 3.44129 7.31607 2.87868 7.87868C2.31607 8.44129 2 9.20435 2 10L2 12C2 12.5523 1.55228 13 1 13C0.447716 13 0 12.5523 0 12L0 10C0 8.67392 0.526785 7.40215 1.46447 6.46447C2.40215 5.52678 3.67392 5 5 5L14.5858 5L11.2929 1.70711C10.9024 1.31658 10.9024 0.683416 11.2929 0.292892Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  )
});